import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import Button from '../../../../../components/Button'
import useResize from '../../../../../hooks/useResize'
import { HUTRIT_CLUB_URL } from '../../../../../services/constants'
import { openNewTab } from '../../../../../utils'
import { VIEWPORT_LG } from '../../../../../utils/constants'
import hutrit_book_desktop from '../../../images/hutrit_book_desktop.webp'
import Toast from '../../../../../components/Toast/Toast'
import { updateTrainingStatus } from '../../../../../services/Training'
import Loader from '../../../../../components/Loader'
import join_hutrit_club_image from '../../../../../assets/join_hutrit_club_image.png'
import HutritClubAcademyStage from './HutritClubAcademyStage'
import './JoinHutritClub.css'

const JoinHutritClub = ({ userData }) => {
  const { t } = useTranslation()
  const viewportSize = useResize()
  const queryClient = useQueryClient()

  const isMobile = viewportSize[0] <= VIEWPORT_LG
  const alreadyHutritClub = userData?.userInfo?.training
  const isAcademyMobile = alreadyHutritClub && isMobile

  const {
    mutate: updateTrainingStatusMutate,
    isLoading: isLoadingUpdateTrainingStatus,
  } = useMutation(['update-training-status'], updateTrainingStatus, {
    onSuccess: ({ status }) => {
      if (status !== 200) {
        Toast({ icon: 'error', title: t('system_error') })
      } else {
        queryClient.invalidateQueries('update-training-status')
        Toast({ title: t('now_you_are_part_of_hutrit_club') })
      }
    },
  })

  return (
    <div
      className={`hutrit-club-container text-on-bg-primary ${
        isAcademyMobile ? 'hutrit-club-container--academy-mobile' : ''
      }`}
      style={
        isAcademyMobile
          ? { backgroundColor: '#ffffff' }
          : {
              backgroundImage: `url(${join_hutrit_club_image})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
            }
      }
    >
      <div
        className={`hutrit-club-content d-flex flex-column align-items-center justify-content-center gap-2 w-100 ${
          alreadyHutritClub ? 'hutrit-club-content--academy' : ''
        }`}
      >
        {alreadyHutritClub ? (
          <HutritClubAcademyStage />
        ) : (
          <>
            <img src={hutrit_book_desktop} width={350} />
            <h1 className={`${isMobile ? 'fontSize24' : 'fontSize40'} fw-bold`}>
              {t('connect_your_talent_with_companies_1')}{' '}
              <br className="d-lg-flex d-none" />
              {t('connect_your_talent_with_companies_2')}
            </h1>
            <span className={`${isMobile ? 'fontSize14' : 'fontSize24'}`}>
              {t('hutrit_club_selects_promising_profiles_1')}{' '}
              <br className="d-lg-flex d-none" />
              {t('hutrit_club_selects_promising_profiles_2')}
            </span>

            <div className="d-flex align-items-center justify-content-center gap-2 w-100">
              <Button
                className="btn-bg-CTA-primary text-on-bg-primary p-3"
                onClick={() => updateTrainingStatusMutate({ state: true })}
              >
                {isLoadingUpdateTrainingStatus ? (
                  <Loader />
                ) : (
                  t('sign_up_now')
                )}
              </Button>
              <Button
                className="btn-bg-transparent border border-on-bg-primary text-on-bg-primary p-3"
                onClick={() => openNewTab({ url: HUTRIT_CLUB_URL })}
              >
                {t('learn_more')}
              </Button>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default JoinHutritClub
